<template>
  <span
    class="font-weight-medium grey--text text--darken-2 mr-4 text-subtitle-2"
  >
    <v-icon
      color="primary"
      class="mr-1 my-1"
    >
      mdi-account-circle
    </v-icon>
      {{ name }}
  </span>
</template>

<script>
  export default {
    name: 'SupervisorItem',

    props: {
      name: String
    }
  }
</script>

<style lang="scss" scoped>

</style>